import { View } from 'react-native';

// styles
import styles from './styles';

export function Card({ children }) {
  return <View style={styles.card}>{children}</View>;
}
